module.exports = __webpack_public_path__ + "static/jan-00d5cc2021c1527526afc390ed7ec86b.png";